export enum ImageType {
  RGB = 'RGB',
  BGR = 'BGR',
}
